import type { ClustersPlatformData, UserSettings } from '../types/local-storage.types';

const STORAGE_KEY = 'CLUSTERS_PLATFORM';

export const getData = (): ClustersPlatformData => {
  try {
    const data = localStorage.getItem(STORAGE_KEY);
    return data ? JSON.parse(data) : {};
  } catch (error) {
    console.error('Błąd podczas odczytu localStorage:', error);
    return {};
  }
};

export const setData = (data: ClustersPlatformData): void => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
  } catch (error) {
    console.error('Błąd podczas zapisu do localStorage:', error);
  }
};

export const getItem = <T extends keyof ClustersPlatformData>(key: T): ClustersPlatformData[T] | undefined => {
  const data = getData();
  return data[key];
};

export const setItem = <T extends keyof ClustersPlatformData>(key: T, value: ClustersPlatformData[T]): void => {
  const data = getData();
  data[key] = value;
  setData(data);
};

export const removeItem = <T extends keyof ClustersPlatformData>(key: T): void => {
  const data = getData();
  delete data[key];
  setData(data);
};

export const clear = (): void => {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch (error) {
    console.error('Błąd podczas czyszczenia localStorage:', error);
  }
};

export const getSettings = (): UserSettings | undefined => {
  const data = getData();
  return data.settings;
};

export const updateSettings = (settings: Partial<UserSettings>): void => {
  const data = getData();
  const currentSettings = data.settings || {};
  data.settings = { ...currentSettings, ...settings } as UserSettings;
  setData(data);
};
